import {useState} from "react";
import Game from "./Game";
import Login from "./Login";

export default function Home() {

    const [user, setUser] = useState<string|undefined>(undefined);

    return (
        <div className="h-screen w-screen grid place-items-center">
            {
                user &&
                <Game user={user} />
            }
            {
                !user &&
                <Login setUser={setUser} />
            }
        </div>
    );

}